<app-header></app-header>

<div class="home-sales-section mt-2">
    <div class="container">
      <div class="row align-items-end">
        <div class="col-sm-12 col-lg-6">
          <div>
            <h1>Home Sales & Refinancing</h1>
          </div>
          <hr />
          <div>
            <p>
              If you decide to sell your home, we will help you transfer the
              solar-system obligations to the buyer, so they can immediately
              enjoy the clean power your home's solar system generates. If
              you've decided to refinance your home, we will work with you and
              your lender to release the filings so you can get this
              accomplished.
            </p>
            <p class="mb-5">
              You can find more information on your options in the <a [routerLink]="['/faq']">FAQs</a> and on
              this page. However, you should also review the information in
              your solar agreement. This will have the most accurate and
              complete description of your home sale options. Contact us early
              in the sale (ideally within 30 days). We can help you understand
              the options and take the appropriate next steps.
            </p>
            <div class="sales-read-more">
              <a (click)="scrollToSection()" class="show-pointer">Read More</a>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-lg-6">
          <div class="home-sales-image pt-4 pl-4 pr-4">
            <img src="/assets/home.jpg" alt="Home image"/>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="select-option" id="Home-Sales-Refinancing">
    <div class="container">
      <div class="row pt-5 pb-5">
        <div class="col-sm-12 col-lg-4 details-card1">
          <div class="text-center">
            <img src="/assets/home.png" alt="Home image"/>
          </div>
          <h2 class="mt-4">Refinancing your home</h2>
          <p class="mt-3">
            You may need to contact us if you refinance your home. We do not
            place a lien on your home in connection with your solar agreement;
            however, we may file documentation such as a UCC Fixture Filing
            and Financing Statement. These documents state that the solar
            equipment installed on your home is owned by the Solar Provider.
            Some lenders will request to see documentation of the solar
            agreement or filings. Upon your request, Spruce can temporarily
            terminate and re-file these documents to allow a refinancing to
            proceed. Please note that there is a service charge associated
            with the temporary termination and refiling.
          </p>
          <p>
            Contact us as early as possible if your lender requests
            documentation or a temporary suspension of the filings.
          </p>
          <p>
            *Homeowner Support may be contacted at <a href="mailto:{{email}}" class="email-color">{{email}}</a> or
            by calling <a href="tel:+18886360336"><span class="number-color">888.636.0336</span></a>.
          </p>
        </div>
        <div class="col-sm-12 col-lg-4 details-card2">
          <div class="text-center">
            <img src="/assets/solar.png" alt="Solar image"/>
          </div>
          <h2 class="mt-4">Selling your home</h2>
          <p class="mt-3">
            In the event you're selling your home we require notice within 30
            days, and 3 weeks prior to the expected close date. This is to
            ensure ample time to update all records and complete your request
            to transfer the lease to the new homeowner(s). Any temporary
            termination of a UCC Fixture Filing and Financing Statement will
            be processed along with this request and refiled in the new
            homeowner(s) name contingent upon the completion of the home sale.
          </p>
          <p>
            To process this request there is an upfront service charge. Our
            Homeowner Support team will be happy to walk you through the
            process and can help with any other questions you may have about
            the UCC filing. *Homeowner Support may be contacted at
            <a href="mailto:{{email}}" class="email-color">{{email}}</a> or by calling
            <a href="tel:+18886360336"><span class="number-color">888.636.0336</span></a>
          </p>
        </div>
        <div class="col-sm-12 col-lg-4 details-card3">
          <div class="text-center">
            <img src="/assets/hamber.png" alt="Hamber image"/>
          </div>
          <h2 class="mt-4">
            Does a UCC filing mean there's a lien on my home?
          </h2>
          <p class="mt-3">
            Your Solar Provider may have filed a Uniform Commercial Code
            Financing Statement on the solar system, aka a UCC-1 fixture
            filing, which appears on the title of your home. Please note, this
            filing is not a lien on your home, rather it is a public record
            that shows that the solar system installed on your home belongs to
            the Solar Provider. Some financing providers may ask to see
            additional documentation about the UCC filing. Upon your request,
            we are able to temporarily terminate and re-file these documents
            to enable your refinancing to proceed. We recommend contacting us
            within 30 days, and at least 3 weeks prior, to the expected close
            date. To process this request there is an upfront service charge.
            Our Homeowner Support team will be happy to walk you through the
            process and can help with any other questions you may have about
            the UCC filing.
          </p>
          <p>
            *Homeowner Support may be contacted at <a href="mailto:{{email}}" class="email-color">{{email}}</a> or
            by calling <span class="number-color">888.636.0336</span>.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="sales-fqa-section">
    <div class="container pt-sm-2 pt-md-2 mt-lg-5 pb-5">
      <div class="row align-items-center">
        <div class="col-sm-12 col-lg-6">
          <div class="sales-image">
            <img src="/assets/house.jpg" alt="House image"/>
          </div>
        </div>
        <div class="col-sm-12 col-lg-6 ps-sm-2 ps-lg-5 pt-5">
          <div class="sles-fqa-title">
            <h1><a [routerLink]="['/faq']" class="text-dark">FAQs</a></h1>
          </div>
          <ul class="sales-fqa">
            <li>Does a UCC filing mean there's a lien on my home?</li>
            <li>Do I need to contact you in regards to a home sale?</li>
            <li>Do I need to contact you in regards to a refinance?</li>
            <li>Steps to take with Spruce when refinancing</li>
            <li>Steps to take with Spruce when selling your home</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="form-select-option">
    <div class="container pt-5 pb-5">
      <div class="row pt-5 pb-5 text-center">
        <div class="col-12">
          <div class="question-section">
            <h1 class="mb-5">Other Questions or Help?</h1>
            <div class="contactus-button mt-4">
              <a [routerLink]="['/get-in-touch']">Contact Us</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-footer></app-footer>
